export default function createPath<T extends Function>(
  pattern: string,
  fn: T,
  meta = { unprotected: false },
) {
  return Object.assign(fn, { pattern, meta });
}
